import { QueryMatchmaking } from '../interfaces/queryMatchmaking.interface';
import EllosAction from '../../../core/interfaces/ellosAction.interface';
import { ActionTypes } from '../../../core/models/actionTypes';

export function queryMatchmakingReducer(state: QueryMatchmaking, action: EllosAction) {
  switch (action.type) {
    case ActionTypes.QueryNewMatchmaking: {
      state = action.payload;
      return state;
    }

    default:
      return state;
  }
}
